const CONFIG = {
    N: 90,
    NODE_FILL_COLOR: [
        '#05B2DC', // level-1
        '#3BC483', // level-2
        '#7FDAFF', // level-3
        '#90EAAA', // level-4   // changes after new design
        '#90EAAA', // levle-5   //  changes after new design
        '#90EAAA',
        '#90EAAA',
        '#90EAAA',
        '#90EAAA',
    ],
    NODE_STROKE_COLOR: '#FCFCFC',
    ACTIVE_FONT_COLOR: ' #E9F1F7',
    INACTIVE_FONT_COLOR: '#2A3747',
    INACTIVE_NODE_OPACITY: 0.1,
    LINK_STROKE_COLOR: '#05B2DC',
    NODE_LIMIT: 5,
    NODE_INITIAL_OFFSET: 1,
};

export default CONFIG;
